import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Amplify } from 'aws-amplify';
import './style/index.scss';
import { Provider } from 'react-redux';
import store from './store';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { initSentry } from './config/sentry';
import { initHotjar } from './config/hotjar';

// import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import './config/i18n';

initSentry();
initHotjar();

// Amplify.Logger.LOG_LEVEL = 'DEBUG';
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID!,
      userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID!,
      passwordFormat: {
        minLength: 12,
      },
    },
  },
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
      retry: false,
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  // <React.StrictMode>
  <React.Suspense fallback="loading">
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <App />
      </Provider>
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
    </QueryClientProvider>
  </React.Suspense>,
  // </React.StrictMode>
);
